// userService.js
import { useEffect } from 'react';
import { API_CONFIG } from './../config'; 

const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.APPINSTALLSEND}`;

export const useTrackUser = () => {
  useEffect(() => {
    const trackNewUser = async () => {
      if (!localStorage.getItem('tracked')) {
        const generatedId = 'USER-' + Math.random().toString(36).substr(2, 9).toUpperCase();
        try {
          const response = await fetch(CREATE_USER_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'userId=' + encodeURIComponent(generatedId)
          });

          if (response.ok) {
            localStorage.setItem('tracked', 'true');
            console.log("User Tracked:", generatedId);
          }
        } catch (error) {
          console.error("Tracking error:", error);
        }
      }
    };

    trackNewUser();
  }, []);
};